import React from 'react';

import { Box, Button, ButtonProps, Stack, styled, useTheme } from '@mui/material';
import { CloseCircle } from 'iconsax-reactjs';
import { LinkProps, Link as NavLink } from 'react-router';

import Logo from '../Logo';

export const CloseButtonStyled = styled(Button)<ButtonProps & Omit<LinkProps, 'variant'>>(
  ({ theme }) => ({
    minWidth: 'unset',
    minHeight: 'unset',
    padding: 0,
    height: theme.spacing(5),
    width: theme.spacing(5),
  }),
);

interface IProps {
  color?: 'primary' | 'secondary';
}

const SecurityHeader = React.memo(({ color = 'secondary' }: IProps) => {
  const theme = useTheme();

  return (
    <Stack direction="row" justifyContent="space-between" width="100%">
      <NavLink to="/auth">
        <Logo />
      </NavLink>

      <Box>
        <CloseButtonStyled
          component={NavLink}
          to="/auth"
          variant="contained"
          color={color}
          size="small"
        >
          <CloseCircle
            size={20}
            color={color === 'primary' ? theme.palette.neutral.main : theme.palette.primary.main}
          />
        </CloseButtonStyled>
      </Box>
    </Stack>
  );
});

export default SecurityHeader;
